import jwtDecode, { JwtPayload } from "jwt-decode";
import { TokenDecryptWorker } from './decryptWorker';

export const isAuthenticated: producer = async ({
    isAuthenticated = update.views[prop._viewId].data.isAuthenticated,
    jwtToken = update.jwtToken,
    ssn = update.ssn,
    updateIsLoading = update.isLoading
}) => {
    updateIsLoading.set(true);
    const worker = new TokenDecryptWorker();

    try {
        const queryParams = new URLSearchParams(window.location.search);
        let encryptedToken = queryParams.get('accessToken');

        if (encryptedToken) {
            window.sessionStorage.setItem('accessToken', encryptedToken);
            queryParams.delete('accessToken');
            const pathname = window.location.pathname;
            const newSearch = queryParams.toString() ? `?${queryParams.toString()}` : '';
            const newUrl = `${pathname}${newSearch}`;
            window.history.replaceState(null, '', newUrl);
        } else {
            encryptedToken = window.sessionStorage.getItem('accessToken');
        }

        if (encryptedToken) {
            try {
                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('Decryption timeout')), 10000);
                });

                const decryptedData = await Promise.race([
                    worker.decrypt(encryptedToken),
                    timeoutPromise
                ]);

                const decryptedToken = decryptedData.token || decryptedData;
                const decodedToken = jwtDecode<JwtPayload>(decryptedToken) as any;
                const currentTime = Math.floor(Date.now() / 1000);

                if (decodedToken.exp && decodedToken.exp > currentTime) {
                    isAuthenticated.set(true);
                    jwtToken.set(decryptedToken);
                    ssn.set(decodedToken.ssn || decodedToken.telephone);
                } else {
                    throw new Error("Token expired");
                }
            } catch (error) {
                console.error("Error processing token:", error);
                isAuthenticated.set(false);
                jwtToken.remove();
                ssn.remove();
                window.sessionStorage.removeItem('accessToken');
            }
        } else {
            isAuthenticated.set(false);
            jwtToken.remove();
            ssn.remove();
            window.sessionStorage.removeItem('accessToken');
        }
    } finally {
        await worker.terminate();
        updateIsLoading.set(false);
    }
}